import type { ReactNode } from 'react';
import { IconButton } from './IconButton';
import styles from './InfoBanner.module.css';

interface InfoBannerProps {
  tone: 'info' | 'success' | 'warning' | 'danger';
  title?: string;
  dismissible?: boolean;
  onDismiss?: () => void;
  icon?: ReactNode;
  children: ReactNode;
}

export function InfoBanner({
  tone,
  title,
  dismissible,
  onDismiss,
  icon,
  children,
}: InfoBannerProps) {
  return (
    <div className={`${styles.banner} ${styles[tone]}`} role="status" data-testid="info-banner">
      {icon && (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      <div className={styles.content}>
        {title && <p className={styles.title}>{title}</p>}
        <div className={styles.body}>{children}</div>
      </div>
      {dismissible && (
        <IconButton
          icon={
            <svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true">
              <path
                d="M1 1l10 10M11 1L1 11"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          }
          aria-label="Dismiss"
          size="sm"
          onClick={onDismiss}
        />
      )}
    </div>
  );
}
